/**
 * QualitySewing.com - Product Compare Tray
 * Lightweight overlay: "Add to Compare" button on sewing machine
 * product pages + persistent floating comparison tray across all pages.
 */
(function() {
  'use strict';

  var STORAGE_KEY = 'qsv-compare-machines';
  var MAX_COMPARE = 3;
  var container = document.getElementById('qsv-compare-tray');
  if (!container) return;

  // HARDCODED CORRECT URL to override any potentially incorrect section settings
  var COMPARE_PAGE = '/pages/sewing-machine-comparison';
  var isMachine = container.getAttribute('data-is-machine') === 'true';

  // Detect if we're on the comparison page (machine-compare app is present)
  var isOnComparePage = !!document.getElementById('machine-compare-app');

  // Current product data (only populated on machine product pages)
  var currentProduct = null;
  if (isMachine) {
    currentProduct = {
      handle: container.getAttribute('data-product-handle'),
      title: container.getAttribute('data-product-title'),
      image: container.getAttribute('data-product-image'),
      url: container.getAttribute('data-product-url'),
      price: container.getAttribute('data-product-price')
    };
  }

  // ---- State ----

  var machines = loadState();
  var _broadcasting = false; // prevents event loops

  function loadState() {
    try {
      var data = localStorage.getItem(STORAGE_KEY);
      if (data) {
        var parsed = JSON.parse(data);
        if (Array.isArray(parsed)) {
          return parsed.filter(function(m) { return m && m.handle; }).slice(0, MAX_COMPARE);
        }
      }
    } catch (e) {}
    return [];
  }

  function saveState() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(machines));
    } catch (e) {}
  }

  function isSelected(handle) {
    return machines.some(function(m) { return m.handle === handle; });
  }

  function broadcastUpdate() {
    _broadcasting = true;
    window.dispatchEvent(new CustomEvent('qsv-compare-updated', {
      detail: { handles: machines.map(function(m) { return m.handle; }) }
    }));
    _broadcasting = false;
  }

  // ---- Tray Rendering ----

  var trayEl = null;
  var maxMsgTimeout = null;

  function buildTrayHtml() {
    var itemsHtml = machines.map(function(m) {
      return '<div class="qsv-ct-item" data-handle="' + m.handle + '">' +
        '<img class="qsv-ct-item-img" src="' + (m.image || '') + '" alt="" loading="lazy">' +
        '<span class="qsv-ct-item-name">' + escapeHtml(m.title) + '</span>' +
        '<button class="qsv-ct-item-remove" data-handle="' + m.handle + '" aria-label="Remove">&times;</button>' +
      '</div>';
    }).join('');

    // On the comparison page, Compare Now triggers the view directly via event
    var compareAction = isOnComparePage
      ? '<button class="qsv-ct-compare-btn" type="button">Compare Now</button>'
      : '<a class="qsv-ct-compare-btn" href="' + buildCompareUrl() + '">Compare Now</a>';

    return '<div class="qsv-ct-tray">' +
      '<div class="qsv-ct-header">' +
        // Dismiss control, first child so it lands at the header's upper left.
        // It clears the selection as well as hiding the tray, i.e. the same
        // action as Clear All. Clear All stays because its label is the one
        // place that spells out what dismissing costs.
        '<button class="qsv-ct-close" type="button" aria-label="Close and clear comparison">&times;</button>' +
        '<span class="qsv-ct-title">Compare Machines</span>' +
        '<span class="qsv-ct-count">' + machines.length + ' of ' + MAX_COMPARE + '</span>' +
        '<button class="qsv-ct-collapse" aria-label="Toggle tray">&#x25BC;</button>' +
      '</div>' +
      '<div class="qsv-ct-items">' + itemsHtml + '</div>' +
      '<div class="qsv-ct-max-msg">Remove a machine to add another.</div>' +
      '<div class="qsv-ct-actions">' +
        '<button class="qsv-ct-clear">Clear All</button>' +
        compareAction +
      '</div>' +
    '</div>';
  }

  function renderTray() {
    if (trayEl) {
      trayEl.remove();
      trayEl = null;
    }

    if (machines.length === 0) return;

    var wrapper = document.createElement('div');
    wrapper.innerHTML = buildTrayHtml();
    trayEl = wrapper.firstChild;
    container.appendChild(trayEl);

    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        if (trayEl) trayEl.classList.add('visible');
      });
    });

    bindTrayEvents();
  }

  function bindTrayEvents() {
    if (!trayEl) return;

    var removeBtns = trayEl.querySelectorAll('.qsv-ct-item-remove');
    for (var i = 0; i < removeBtns.length; i++) {
      removeBtns[i].addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        removeMachine(this.getAttribute('data-handle'));
      });
    }

    var clearBtn = trayEl.querySelector('.qsv-ct-clear');
    if (clearBtn) {
      clearBtn.addEventListener('click', function(e) {
        e.preventDefault();
        clearAll();
      });
    }

    var compareBtn = trayEl.querySelector('.qsv-ct-compare-btn');
    if (compareBtn && isOnComparePage) {
      compareBtn.addEventListener('click', function(e) {
        e.preventDefault();
        window.dispatchEvent(new CustomEvent('qsv-compare-now'));
      });
    }

    var closeBtn = trayEl.querySelector('.qsv-ct-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        clearAll();
      });
    }

    var collapseBtn = trayEl.querySelector('.qsv-ct-collapse');
    if (collapseBtn) {
      collapseBtn.addEventListener('click', function(e) {
        e.preventDefault();
        trayEl.classList.toggle('collapsed');
      });
    }
  }

  function showMaxMessage() {
    if (!trayEl) return;
    var msg = trayEl.querySelector('.qsv-ct-max-msg');
    if (!msg) return;
    msg.classList.add('show');
    if (maxMsgTimeout) clearTimeout(maxMsgTimeout);
    maxMsgTimeout = setTimeout(function() {
      msg.classList.remove('show');
    }, 3000);
  }

  // ---- Button Injection ----

  var btnEl = null;

  function findInjectionPoint() {
    var selectors = [
      '.product-form__buttons',
      '.product-form__submit',
      'form[action*="/cart/add"] .shopify-payment-button',
      'form[action*="/cart/add"] button[type="submit"]',
      '.product-form',
      '.product__info-wrapper',
      '.product-single__meta'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function injectButton() {
    if (!isMachine || !currentProduct) return false;
    var target = findInjectionPoint();
    if (!target) return false;

    var selected = isSelected(currentProduct.handle);
    btnEl = document.createElement('button');
    btnEl.type = 'button';
    btnEl.id = 'qsv-ct-product-btn';
    btnEl.className = 'qsv-ct-btn' + (selected ? ' active' : '');
    btnEl.innerHTML = '<span class="qsv-ct-btn-icon">' + (selected ? '&#10003;' : '+') + '</span> ' +
      '<span class="qsv-ct-btn-text">' + (selected ? 'Added to Compare' : 'Add to Compare') + '</span>';

    btnEl.addEventListener('click', function(e) {
      e.preventDefault();
      toggleCurrent();
    });

    var insertAfter = target;
    if (target.tagName === 'BUTTON' || target.tagName === 'INPUT') {
      insertAfter = target.closest('.product-form__buttons') || target.parentElement;
    }

    if (insertAfter.nextSibling) {
      insertAfter.parentNode.insertBefore(btnEl, insertAfter.nextSibling);
    } else {
      insertAfter.parentNode.appendChild(btnEl);
    }
    return true;
  }

  function updateButton() {
    if (!btnEl || !currentProduct) return;
    var selected = isSelected(currentProduct.handle);
    btnEl.className = 'qsv-ct-btn' + (selected ? ' active' : '');
    btnEl.querySelector('.qsv-ct-btn-icon').innerHTML = selected ? '&#10003;' : '+';
    btnEl.querySelector('.qsv-ct-btn-text').textContent = selected ? 'Added to Compare' : 'Add to Compare';
  }

  // ---- Actions ----

  function toggleCurrent() {
    if (!currentProduct) return;
    if (isSelected(currentProduct.handle)) {
      removeMachine(currentProduct.handle);
    } else {
      addMachine(currentProduct);
    }
  }

  function addMachine(machineData) {
    if (isSelected(machineData.handle)) return;
    if (machines.length >= MAX_COMPARE) {
      showMaxMessage();
      return;
    }
    machines.push({
      handle: machineData.handle,
      title: machineData.title,
      image: machineData.image,
      url: machineData.url,
      price: machineData.price
    });
    saveState();
    renderTray();
    updateButton();
    broadcastUpdate();
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'compare_tray_add', compare_machine: machineData.handle, compare_count: machines.length }); } catch (e) {}
  }

  function removeMachine(handle) {
    machines = machines.filter(function(m) { return m.handle !== handle; });
    saveState();
    renderTray();
    updateButton();
    broadcastUpdate();
  }

  function clearAll() {
    machines = [];
    saveState();
    renderTray();
    updateButton();
    broadcastUpdate();
  }

  // ---- URL Builder ----

  function buildCompareUrl() {
    var handles = machines.map(function(m) { return m.handle; });
    // Priority: ALWAYS use the hardcoded correct URL for consistency
    return COMPARE_PAGE + '?compare=' + handles.join(',');
  }

  // ---- Sync ----

  window.addEventListener('storage', function(e) {
    if (e.key !== STORAGE_KEY) return;
    machines = loadState();
    renderTray();
    updateButton();
  });

  window.addEventListener('qsv-compare-updated', function(e) {
    if (_broadcasting) return;
    machines = loadState();
    renderTray();
    updateButton();
  });

  // Listen for collapse/expand requests from the comparison app
  window.addEventListener('qsv-compare-tray-collapse', function(e) {
    if (!trayEl) return;
    if (e.detail && e.detail.collapsed === true) {
      trayEl.classList.add('collapsed');
    } else {
      trayEl.classList.remove('collapsed');
    }
  });

  // ---- Utilities ----

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  // ---- Init ----

  function init() {
    if (machines.length > 0) {
      renderTray();
    }
    if (isMachine) {
      if (!injectButton()) {
        var retries = 0;
        var retryTimer = setInterval(function() {
          retries++;
          if (injectButton() || retries >= 10) {
            clearInterval(retryTimer);
          }
        }, 200);
      }
    }
  }

  init();

})();
